const initialState = {
    statusShow: false,
    order: {},
    loader: false,
    cancelLoader: false
};
const modalInvoice = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_HANDLE_MODAL_INVOICE':
            return {...state, statusShow: action.statusShow};
        case 'GET_DATA_INVOICE_IN_API_MODAL_INVOICE':
            return {...state, order: action.order};
        case 'CHANGE_LOADER_MODAL_INVOICE':
            return {...state, loader: action.loader};
        case 'CHANGE_LOADER_CANCEL_MODAL_INVOICE':
            return {...state, cancelLoader: action.cancelLoader};
        default:
            return state;
    }
};

export default modalInvoice;
